import { render, staticRenderFns } from "./PushListDataTable.vue?vue&type=template&id=3cb0340a&scoped=true"
import script from "./PushListDataTable.vue?vue&type=script&lang=js"
export * from "./PushListDataTable.vue?vue&type=script&lang=js"
import style0 from "./PushListDataTable.vue?vue&type=style&index=0&id=3cb0340a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb0340a",
  null
  
)

export default component.exports